import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelDashboardOption,
  toggleWorkspaceVisibility,
} from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import { ConfirmationDialog } from "./ConfirmationDialog";

export const HideWorkspaceDialog = () => {
  const dispatch = useDispatch();

  const t = useI18n("HIDE_WORKSPACE_DIALOG.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  return (
    <ConfirmationDialog
      buttonText={t("HIDE")}
      cancelAction={() => dispatch(cancelDashboardOption())}
      icon="hoylu-ui-icons-x"
      message={t("WARNING")}
      submitAction={() =>
        selectedWorkspace &&
        dispatch(toggleWorkspaceVisibility.request(selectedWorkspace))
      }
      title={`${t("HIDE")} "${selectedWorkspace?.workspaceName}"`}
    />
  );
};

export default HideWorkspaceDialog;
